import apiBase from "../../api/axios";

export const getMentoresSeguimientoService = async () => {
  const response = await apiBase.get("v1/seguimiento/mentores/");
  return response.data;
};

export const getEstudiantesSinAsignarService = async (mentorId) => {
  const response = await apiBase.get(
    `v1/seguimiento/estudiantes-sin-asignar/?mentor_id=${mentorId}`
  );
  return response.data;
};

// El backend envuelve las respuestas de POST/PUT/PATCH/DELETE en
// { message, data, status_code } vía CustomJSONRenderer.
// Devolvemos siempre la carga útil real (`data`), con fallback al body plano.
const unwrap = (body) =>
  body && typeof body === "object" && "data" in body ? body.data : body;

export const asignarEstudiantesService = async (data) => {
  const response = await apiBase.post("v1/seguimiento/asignar/", data);
  return unwrap(response.data);
};

/**
 * Cambia el mentor de un estudiante.
 * @param {{ estudiante_id:number, nuevo_mentor_id:number, motivo:string }} payload
 */
export const reasignarMentorService = async (payload) => {
  const response = await apiBase.post("v1/seguimiento/reasignar/", payload);
  return unwrap(response.data);
};

export const getAsignacionesMentorService = async (mentorId) => {
  const response = await apiBase.get(
    `v1/seguimiento/asignaciones/?mentor_id=${mentorId}`
  );
  return response.data;
};

export const inactivarAsignacionService = async (id) => {
  const response = await apiBase.patch(`v1/seguimiento/${id}/inactivar/`);
  return unwrap(response.data);
};

export const activarAsignacionService = async (id) => {
  const response = await apiBase.patch(`v1/seguimiento/${id}/activar/`);
  return unwrap(response.data);
};

export const eliminarAsignacionService = async (id) => {
  const response = await apiBase.delete(`v1/seguimiento/${id}/eliminar/`);
  return unwrap(response.data);
};

/**
 * Lista los alumnos visibles para el usuario autenticado (mentor / admin).
 * @param {{ search?: string, plantelId?: number|string }} params
 */
export const getAlumnosSeguimientoService = async ({ search, plantelId } = {}) => {
  const params = new URLSearchParams();
  if (search) params.set("search", search);
  if (plantelId) params.set("plantel_id", plantelId);
  const query = params.toString() ? `?${params.toString()}` : "";
  const response = await apiBase.get(`v1/seguimiento/alumnos/${query}`);
  return response.data;
};

/**
 * Planteles disponibles como filtro para "Mis alumnos".
 */
export const getPlantelesAlumnosService = async () => {
  const response = await apiBase.get("v1/seguimiento/alumnos/planteles/");
  return response.data;
};

/**
 * Detalle completo del estudiante: perfil + talentos + 7 fortalezas.
 * @param {number} usuarioId
 */
export const getAlumnoDetalleService = async (usuarioId) => {
  const response = await apiBase.get(
    `v1/seguimiento/alumnos/${usuarioId}/detalle/`,
  );
  return response.data;
};
